import React from 'react'
import PropTypes from 'prop-types'
import ButtonLink from '../../ButtonLink'

const ToggleButton = ({ theme, onCallback, label, setOpen, styles }) => (
  <ButtonLink
    className={styles.button}
    theme={theme}
    label={label}
    onClick={() => {
      setOpen()
      if (onCallback) onCallback()
    }}
  />
)

ToggleButton.propTypes = {
  onCallback: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  theme: PropTypes.oneOf(['', 'primary', 'secondary', 'success', 'warning', 'error', 'legacy', 'dark', 'tertiary', 'info']).isRequired,
  setOpen: PropTypes.func.isRequired,
  styles: PropTypes.shape({
    button: PropTypes.string,
  }).isRequired,
}

export default ToggleButton
